if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange() {
      this.updateSelectedOptions();
      this.updateVariant();
    }

    updateSelectedOptions() {
      const groups = Array.from(this.querySelectorAll('.product-form__input'));
      this.selectedOptions = groups
        .map((group) => {
          const checkedInput = group.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
          if (checkedInput) return checkedInput.value;
          const select = group.querySelector('select');
          if (select) return select.value;
          return null;
        })
        .filter((value) => value !== null);
    }

    getVariantData() {
      if (!this.variantData) {
        const jsonScript = this.querySelector('script[type="application/json"]');
        this.variantData = jsonScript ? JSON.parse(jsonScript.textContent) : [];
      }
      return this.variantData;
    }

    updateVariant() {
      const variants = this.getVariantData();
      const selected = this.selectedOptions || [];

      const variant = variants.find((v) => {
        if (!Array.isArray(v.options)) return false;
        return v.options.every((value, index) => value === selected[index]);
      });

      if (!variant) return;

      this.dispatchEvent(
        new CustomEvent('variant:change', {
          bubbles: true,
          detail: { variant }
        })
      );
    }
  });
}

if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('variant:change', this.handleVariantChange.bind(this));
    }

    handleVariantChange(event) {
      const variant = event && event.detail ? event.detail.variant : null;
      if (!variant) return;

      this.querySelectorAll('.product-variant-id').forEach((input) => {
        input.value = variant.id;
      });

      const variantSelects = this.querySelector('variant-selects');
      if (variantSelects && variantSelects.dataset.updateUrl !== 'false' && variantSelects.dataset.url) {
        window.history.replaceState({}, '', `${variantSelects.dataset.url}?variant=${variant.id}`);
      }

      if (variant.featured_media) {
        const mediaId = `${this.dataset.section}-${variant.featured_media.id}`;
        document
          .querySelectorAll(`media-gallery[data-section="${this.dataset.section}"]`)
          .forEach((gallery) => {
            if (typeof gallery.setActiveMedia === 'function') {
              gallery.setActiveMedia(mediaId, true);
            }
          });
      }

      const submitButton = this.querySelector(`#ProductSubmitButton-${this.dataset.section}`);
      if (submitButton) {
        submitButton.toggleAttribute('disabled', !variant.available);
      }
    }
  });
}
